import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import Icons from 'consts/icons';
import { FiltersDetailsUseStyles } from 'components/common/components/filters/FiltersUseStyles';
import RangeDateTimePicker from './RangeDateTimePicker';

const FilterDateTime = props => {
  const { setFiltersDateTime, setFiltersDateTimeMissions } = props;
  const [selectedStartDate, setSelectedStartDate] = React.useState(null);
  const [selectedEndDate, setSelectedEndDate] = React.useState(null);
  const classes = FiltersDetailsUseStyles();

  const handleStartDateChange = date => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = date => {
    setSelectedEndDate(date);
  };

  const returnFilterRequest = () => {
    const filterObject = {};
    if (selectedStartDate >= 0)
      filterObject.start = new Date(selectedStartDate).getTime();
    if (selectedEndDate > 0)
      filterObject.stop = new Date(selectedEndDate).getTime();
    else filterObject.stop = new Date(Date.now()).getTime();
    return filterObject;
  };

  const handleSubmitForm = () => {
    const requestFilterObject = returnFilterRequest();
    setFiltersDateTime(requestFilterObject);
    if (setFiltersDateTimeMissions)
      setFiltersDateTimeMissions(requestFilterObject);
  };

  const handleClearCalendar = () => {
    setSelectedStartDate(0);
    setSelectedEndDate(0);
  };

  React.useEffect(() => {
    if (selectedEndDate === 0 && selectedStartDate === 0) handleSubmitForm();
  }, [selectedEndDate, selectedStartDate]);

  return (
    <Grid
      container
      className={`${classes.FiltersDetails}__table ${classes.FiltersDetails}__table__calendar`}
    >
      <Grid
        item
        xs={11}
        className={`${classes.FiltersDetails}__table__calendar--flex`}
      >
        <RangeDateTimePicker
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
          handleStartDateChange={handleStartDateChange}
          handleEndDateChange={handleEndDateChange}
        />
      </Grid>
      <Grid
        item
        xs={1}
        className={`${classes.FiltersDetails}__table__calendar__search`}
      >
        <Button
          type="submit"
          form="filterform"
          className={`${classes.FiltersDetails}__table__filters__search__button`}
          onClick={handleSubmitForm}
        >
          <Icons.Actions.SearchEvent />
        </Button>
        <Button
          type="button"
          className={`${classes.FiltersDetails}__table__filters__search__button`}
          onClick={handleClearCalendar}
        >
          <Icons.Filters.ClearCalendar />
        </Button>
      </Grid>
    </Grid>
  );
};

FilterDateTime.propTypes = {
  setFiltersDateTime: PropTypes.func,
  setFiltersDateTimeMissions: PropTypes.func,
};

export default FilterDateTime;
